var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11H14C12.8954 11 12 11.8954 12 13V29C12 30.1046 12.8954 31 14 31H26C27.1046 31 28 30.1046 28 29V13C28 11.8954 27.1046 11 26 11H24V11.5C24 12.3284 23.3284 13 22.5 13H17.5C16.6716 13 16 12.3284 16 11.5V11Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11H14C12.8954 11 12 11.8954 12 13V29C12 30.1046 12.8954 31 14 31H26C27.1046 31 28 30.1046 28 29V13C28 11.8954 27.1046 11 26 11H24V11.5C24 12.3284 23.3284 13 22.5 13H17.5C16.6716 13 16 12.3284 16 11.5V11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10H22.5C22.7761 10 23 10.2239 23 10.5V11.5C23 11.7761 22.7761 12 22.5 12H17.5C17.2239 12 17 11.7761 17 11.5V10.5C17 10.2239 17.2239 10 17.5 10H19C19 9.44772 19.4477 9 20 9C20.5523 9 21 9.44772 21 10Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10H22.5C22.7761 10 23 10.2239 23 10.5V11.5C23 11.7761 22.7761 12 22.5 12H17.5C17.2239 12 17 11.7761 17 11.5V10.5C17 10.2239 17.2239 10 17.5 10H19C19 9.44772 19.4477 9 20 9C20.5523 9 21 9.44772 21 10Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#00A3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#00A3FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#00A3FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#00A3FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#00A3FF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/cardIcon2.29293a1201928c9ca3e40082849c8a32.svg";
export { ForwardRef as ReactComponent };